import { render, staticRenderFns } from "./EventDates.vue?vue&type=template&id=3929f4ad&"
import script from "./EventDates.vue?vue&type=script&lang=ts&"
export * from "./EventDates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports